export enum AthleteProfileRoleName {
	Owner = "owner",
	ReadOnly = "read only",
}
export enum AthleteProfileRelationshipName {
	Athlete = "athlete",
	Parent = "parent",
	Other = "other",
}